// frontend/src/components/layouts/RoleAwareLayout.js
/**
 * RoleAwareLayout - Smart Layout Component
 * 
 * Automatically renders the correct sidebar based on user type.
 * This prevents the common bug of using the wrong layout for shared components.
 * 
 * Usage:
 *   import RoleAwareLayout from '../../components/layouts/RoleAwareLayout';
 *   
 *   return (
 *     <RoleAwareLayout>
 *       {content}
 *     </RoleAwareLayout>
 *   );
 * 
 * Supported User Types:
 *   - 'freelancer' → FreelancerSidebarLayout
 *   - 'professional' → StaffSidebarLayout (if needed in future)
 *   - 'business' (default) → SidebarLayout (R1 business owner)
 */

import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import FreelancerSidebarLayout from '../../pages/freelancer/FreelancerSidebarLayout';
import SidebarLayout from '../../pages/shops/SidebarLayout';

const RoleAwareLayout = ({ children }) => {
  const { userType } = useAuth();

  // Render appropriate layout based on user type
  switch (userType) {
    case 'freelancer':
      return <FreelancerSidebarLayout>{children}</FreelancerSidebarLayout>;
    
    case 'professional':
      // Future: Add StaffSidebarLayout when professionals get their own sidebar
      // For now, fall through to default business layout
      return <SidebarLayout>{children}</SidebarLayout>;
    
    case 'business':
    default:
      // R1 business owner - default layout
      return <SidebarLayout>{children}</SidebarLayout>;
  }
};

export default RoleAwareLayout;
